import "./GiftTarget.css";
import { TbCrown } from "react-icons/tb";
import { BsClock, BsTruck } from "react-icons/bs";
import { GiRank1 } from "react-icons/gi";
import { GoGoal } from "react-icons/go";
import { useFetchData } from "../../../hooks/useFetchData";
import { useEffect, useState } from "react";
import { formatArabicDate, getPercentage } from "../../../utils/dateformat";
import { useAuthContext } from "../../../hooks/useAuthContext";
function GiftTarget({isHidden, competition}) {
  const {data} = useFetchData("mandoub/competition?scope=stats");
  const {auth} = useAuthContext();
  

  const [compet, setcompet] = useState({});


  const [top3, setTop3] = useState([])
  const [authStats, setauthStats] = useState({})

  useEffect(() => {
    if (compet && compet[0] && auth) {
      
      const cm = compet[0].stats.filter((item)=>item._id === auth.user._id);
      setauthStats(cm[0]);
    }
  }, [compet, auth]);
  useEffect(() => {
    if (data?.allTransactionStats) {
      
      const cm = data.allTransactionStats.filter((item)=>item.competitionId === competition._id);
      setcompet(cm);
    }
  }, [data]);
  useEffect(() => {
    if (compet && compet[0]) {
      const top3 = compet[0]?.stats.slice(0, 3);
      setTop3(top3);
    }
  }, [compet]);

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const startDate = new Date(competition.startDate);
      const difference = startDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);

        setTimeLeft({ days, hours, minutes });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 60000); 

    return () => clearInterval(timer);
  }, [competition.startDate]);


  
  
  
  
  const { days, hours, minutes } = timeLeft;
  
  
  
  return (
    <div className={`df-c main--container section-card ${isHidden ? "bluried" : ""}`}>
      {
       isHidden === true && (
        <section className="coming-soon">
          <div className="coming-soon-inner">
            <h1 className="heading">مسابقة جديدة </h1>
            <h2 className="small-heading">استعدوا للمسابقة القادمة</h2>
            <div className="counter-timer">
            <ul>
              <li><span id="days">{days}</span> أيام</li>
              <li><span id="hours">{hours+1}</span> ساعات</li>
              <li><span id="minutes">{minutes+1}</span> دقائق</li>
            </ul>
            </div>
          </div>
        </section>
      )
      
      }
      <div className={`df ${isHidden ? "blur" : ""}`}>
      <div className="df-c gift--container">
        <div className="title">معلومات عن الهدية</div>
          {top3 && compet && compet[0] && <div className="gift--target df mt-10">
            <div className="uss w-20 h-20">
              <div className="magicpattern"></div>
              <img src={auth?.user.img? process.env.REACT_APP_UPLOADS_DIR+auth?.user.img : "/img/default.png" } className="object-cover" alt="" srcSet="" />
            </div>
            <div className="target">
            {
  top3.slice(0, 2).map((item) =>
    item._id !== auth?.user._id && (
      <div
        key={item._id}  // ✅ Added key here
        className="top"
        style={{ right: `${getPercentage(competition.target, item.totalQuantity)}%` }}
      >
        <img
          src={item.img ? process.env.REACT_APP_UPLOADS_DIR + item.img : "/img/default.png"}
          alt=""
        />
      </div>
    )
  )
}

            
            <div className="line" style={{ width: `${getPercentage(competition?.target, authStats?.totalQuantity)}%` }}></div>

            </div>
            <div className="uss w-20 h-20">
              <div className="magicpattern"></div>
              <img src={competition?.gift?.image || "/img/iphone.png" } className="object-cover" alt="" srcSet="" />
            </div>
          </div>}
                  {competition && (
          <div className="df gif-info">
            <div className="uss gift-img-img">
              <div className="magicpattern"></div>
              <img 
                src={competition?.gift?.image || "/img/default.png" } 
                className="object-cover" 
                srcSet="" 
              />
            </div>
            <ul>
              <li className="title">{competition.gift.name}</li>
              <li>
                {competition.gift.description}
              </li>
            </ul>
          </div>
        )}

          {authStats &&<div className="df-c !g2 stt">
            <div className="df w-full">
              <div className="df !gap-2 w-1/2">
                <div className="rounded-icon  !rounded-md">
                  <BsTruck />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{authStats.totalQuantity}</div>
                  <div className='text'>الكمية المباعة</div>
                </div>
              </div>
              <div className="df">
                <div className="rounded-icon yellowed  !rounded-md">
                  <GoGoal />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{competition?.target}</div>
                  <div className='text'>الكمية المطلوبة</div>
                </div>
              </div>
            </div>
            <div className="df w-full">
              <div className="df !gap-2 w-1/2">
                <div className="rounded-icon pinked  !rounded-md">
                  <BsClock />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{formatArabicDate(competition.endDate)}</div>
                  <div className='text'>الموعد النهائي</div>
                </div>
              </div>
              <div className="df">
                <div className="rounded-icon errored !rounded-md">
                  <GiRank1 />
                </div>
                <div className="df-c g0">
                  <div className='text-black font-bold'>{competition?.target - authStats.totalQuantity}</div>
                  <div className='text'>متبقي</div>
                </div>
              </div>
            </div>
          </div>}
        </div>
        <div className="df-c leaderboard">
        <div className="title">لوحة صدارة المسابقة</div>
        <div  className={`df jc-sb`}>
        {top3 && top3.map((item, index) => (
    <div key={item._id} className={`leader-box ${index === 0 ? 'leader1 top1 leader' : index === 1 ? 'leader2 leader' : 'leader3 leader'} trans`}>
      <div className="img">
        <img
          src={item.img? process.env.REACT_APP_UPLOADS_DIR+item.img : "/img/default.png" } // Assuming the image path is dynamic
          alt={item.fullName}
          srcSet=""
        />
        <div className="rank">{index + 1}</div>
        {index === 0 && <TbCrown className="crown" />}
      </div>
      <div className="df-c ai-c">
        <span>{item.fullName}</span>
        <div className="score">{item.totalQuantity} كغ</div>
        <div className="df-c w-full !gap-1">
          <div className="df w-full jc-sb">
            <span>{getPercentage(competition.target, item.totalQuantity)}%</span> {/* Adjust percentage logic as needed */}
            <span>النقاط</span>
          </div>
          <div className="range w-full">
            <div className="bar-cont">
              <div className="barprog" style={{ width: `${getPercentage(competition.target, item.totalQuantity)}%` }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
))}
  </div>


  
  <div className="table-leader-container mt-28">
    <table className="content-table">
      <thead>
        <tr>
          <th>الاسم</th>
          <th>الأوزان</th>
          <th>النقاط</th>
        </tr>
      </thead>
      {compet && compet[0] && (
  <tbody>
    {compet[0].stats.map((item, index) => {
      const isActive = item._id === auth?.user._id; 
      return (
        <tr key={item._id} className={isActive ? 'active-row' : ''}>
          <td>
            <div className={`df relative w-fit`}>
              <div className="rank">{index + 1}</div>
              <div className="order-cus-img">
                <img src={item.img? process.env.REACT_APP_UPLOADS_DIR+item.img : "/img/default.png" } alt="customer" />
              </div>
              <div className="df-c g0">
                <div className="bold-1 h-4 leading-none text-right">{item.fullName}</div>
                <div className="text leading-none h-4 text-xs">{item.email}</div>
              </div>
            </div>
          </td>
          <td>
            <span className="bold-1 text-indigo-600">{item.totalQuantity} كغ</span>
          </td>
          <td>
            <div className="df-c w-full !gap-1">
              <div className="df w-full jc-sb">
                <span>{item.totalQuantity > 0 ? getPercentage(competition.target, item.totalQuantity) : 0}%</span>
                <span>النقاط</span>
              </div>
              <div className="range w-full">
                <div className="bar-cont">
                  <div className="barprog" style={{ width: `${getPercentage(competition.target, item.totalQuantity)}%` }}></div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    })}
  </tbody>
)}

    </table>
  </div>
</div>

      </div>
    </div>
  );
}

export default GiftTarget;
